$(document).ready(function(){
    $('.search-icon').on('click', function() {
        if($('.navbar-collapse').hasClass('show')) {
            $('#main-menu-toggler').click();
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/mobile-menu-collapse.js
// module id = 23
// module chunks = 0